export default "__VITE_ASSET__ad588b6d__"